// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectsTableTbodyColumn_wrapper__qzHYB"};